import { MainLayout } from "../layouts/MainLayout";
import { getLocalizedString } from "../utils";

const MyOrdersPage = () => {
  return <MainLayout>{getLocalizedString("I miei ordini")}</MainLayout>;
};

export { MyOrdersPage };
